import { Joi, objectSchemaOf } from '../helpers';

export interface IJobsClaimResult {
  conversationId?: string;
}

export const jobsClaimResultSchema = objectSchemaOf<IJobsClaimResult>({
  conversationId: Joi.string().optional(),
});
